// removed by extract-text-webpack-plugin
module.exports = {"dialog-lg":"_3IWTc","dialog-lg-top":"qGoPo"};


//////////////////
// WEBPACK FOOTER
// ./routes/Modal/container/style.scss
// module id = 961
// module chunks = 2